/**
 * Submission Response.
 * @format
 */

import React from 'react';
import { useSafeTranslate } from '@hooks/use-safe-translate';

/**
 * Submission Response.
 */
const FormResponse: React.FC<{ message?: string }> = ({ message }) => {
  const thankYou = useSafeTranslate('Thank you');
  const submissionReceived = useSafeTranslate(
    'Your submission has been received.'
  );
  const successMessage = message ?? submissionReceived;

  /**
   * Render.
   */
  return (
    <div className={`response success-message`}>
      <h2>{thankYou}</h2>
      <p dangerouslySetInnerHTML={{ __html: successMessage ?? '' }} />
    </div>
  );
};
export default FormResponse;
